export default ($) => {
    var sidebar = $('.js-sidebar');
    var sidebarTrigger = $('.js-sidebar-trigger');

    sidebarTrigger.on('click', function () {
        sidebar.toggleClass('active');
    });
}